import { useNotificationsStore } from '~/stores/notifications'

export type KftNotificationType = 'INFO' | 'SUCCESS' | 'WARNING' | 'ERROR'

export interface KftNotification {
  title?: string
  message: string
  type: KftNotificationType
  showIcon?: boolean
  htmlContent?: string
  persist?: boolean
}

export const useNotifications = () => {
  const store = useNotificationsStore()

  return {
    notifications: store.notifications,
    addNotification: store.addNotification,
    handleCloseNotification: store.handleCloseNotification,
  }
}
